<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import Mgr from './services/SecurityService'

export default {
  data () {
    return {
      vueAppClasses: [],
      mgr: new Mgr(),
      signedIn: false
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
    // ,
    // signedIn (val) {
    //   if (val) {
    //     this.mgr.getUser().then(user  => {
    //       this.$store.dispatch('fetchCustomerByUserName', user.profile.email).then(customerInfo => {
    //       console.error(user)
    //         if (user !== null) this.$store.dispatch('updateUserInfo', {displayName : `${customerInfo.data.firstName} ${customerInfo.data.lastName}`, email : user.profile.email, customerId : customerInfo.data.id})
    //       })
    //     })
    //   }
    // }
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {
    
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

  },
  async created () {
    this.mgr.getUser().then(async user  => {
      if (user !== null) {
        console.error(user)
        this.$store.dispatch('fetchCustomerByUserName', user.profile.email).then(customerInfo => {
          this.$store.dispatch('updateUserInfo', {displayName : `${customerInfo.data.firstName} ${customerInfo.data.lastName}`, email : user.profile.email, customerId : customerInfo.data.id})
        })
      }
    })
     
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    window.getEnumCurrencies = function getEnumCurrencies () {
      const currency = [
        {value: 1, chipText: 'USD', chipColor: 'danger'}, 
        {value: 2, chipText: 'EUR', chipColor: 'danger'}, 
        {value: 3, chipText: 'GBP', chipcolor: 'danger'}, 
        {value: 4, chipText: 'USC', chipcolor: 'danger'}, 
        {value: 5, chipText: 'BTC', chipcolor: 'danger'}, 
        {value: 6, chipText: 'TRY', chipcolor: 'danger'}, 
        {value: 7, chipText: 'IRR', chipcolor: 'danger'}
      ]
      return currency
    }

    window.getEnumTransactionTypes = function getEnumTransactionTypes () {
      const transactionType = [
        {value: 201, chipText: 'Deposit', chipColor: 'success'}, 
        {value: 202, chipText: 'Withdrawal', chipColor: 'danger'},
        {value: 102, chipText: 'Transfer Out', chipColor: 'grey'}, 
        {value: 101, chipText: 'Transfer In', chipColor: 'grey'}
      ]
      return transactionType
    }

    window.getEnumTransactionStatuses = function  getEnumTransactionStatuses () {
      const status = [
        {value: 1, chipText: 'Completed', chipColor: 'success'},
        {value: 2, chipText: 'Pending', chipColor: 'grey'},
        {value: 3, chipText: 'Reversed', chipColor: 'warning'},
        {value: 4, chipText: 'Error', chipColor: 'danger'},
        {value: 5, chipText: 'Canceled', chipColor: 'warning'},
        {value: 6, chipText: 'Hold', chipColor: 'grey'},
        {value: 7, chipText: 'Insufficient', chipColor: 'warning'},
        {value: 8, chipText: 'Fraud', chipColor: 'warning'}
      ]
      return status
    }

    window.getEnumLanguages = function getEnumLanguages () {
      const lang = [
        { label: 'English', id: 'en'},
        { label: 'Spanish', id: 'es'},
        { label: 'French', id: 'fr'},
        { label: 'Russian', id: 'ru'},
        { label: 'German', id: 'ge'},
        { label: 'Arabic', id: 'ar'},
        { label: 'Turkish', id: 'tr'},
        { label: 'Sanskrit', id: 'sa'}
      ]
      return lang
    }

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
